import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../../SvgIcons/CreateIconComponent';

export type HotAirBalloonIconProps = CreateIconComponentProps;
export const HotAirBalloonIcon: React.FC<HotAirBalloonIconProps> = ({
  title = 'HotAirBalloon',
  viewBox = '0 0 24 24',
  ...rest
}) => (
  <CreateIconComponent title={title} viewBox={viewBox} {...rest} fill="none">
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M13.8 17.429c-.229-1.417 1.291-2.85 2.4-3.858 2.41-1.66 3.393-4.55 2.44-7.175C17.688 3.77 15.013 2 12 2S6.312 3.77 5.36 6.396c-.953 2.625.03 5.515 2.44 7.175 1.109 1.008 2.629 2.44 2.4 3.858"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M12 2c-1 1.167-3 4.1-3 6.5 0 4 2.5 2.5 2.5 9"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M11.9 2c1 1.167 3 4.1 3 6.5 0 4-2.5 2.5-2.5 9M9 18h6v3a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-3Z"
    />
  </CreateIconComponent>
);
